"use strict";

define('rs/modals/upload/upload.controller',['require','exports','module','e3-modal','rs/modals/upload/upload.view','rs/errors','rs/models/docstore','rs/models/link','evisions/uuid'],function (require, exports, module) {
  var E3Modal = require('e3-modal');
  var UploadView = require('rs/modals/upload/upload.view');
  var RSErrors = require('rs/errors');
  var DocStore = require('rs/models/docstore');
  var LinkModel = require('rs/models/link');
  var prefixUuid = require('evisions/uuid');
  var UploadController = E3Modal.SectionController.extend({
    defaultTitle: 'Upload File',
    properties: ['documentId', 'uploadQueue', 'failedFiles', 'multiple', 'files', 'ariaControls'],
    buttons: [{
      icon: 'plus',
      action: 'Add',
      position: 'left',
      ariaLabel: 'add'
    }, {
      text: 'Cancel',
      icon: 'ban',
      dismiss: true
    }, {
      text: 'Apply',
      icon: 'save',
      color: 'primary',
      action: 'apply',
      ariaControls: ''
    }],
    setupView: function setupView() {
      this.setView(new UploadView());
    },
    initialize: function initialize(properties) {
      var approveButton;
      this.setFiles([]);
      this.setUploadQueue([]);
      this.setFailedFiles([]);
      if (properties) {
        if (properties.multiSelect === true) {
          properties.multiple = true;
        }
        if (properties.ariaControls) {
          approveButton = _.findWhere(this.getButtons(), {
            action: 'apply'
          });
          approveButton.ariaControls = properties.ariaControls;
        }
      }
      this._super.apply(this, arguments);
      this.sync('files').sync('uploadQueue');
    },
    processFile: function processFile(file) {
      if (!file.uuid) {
        if (file.link) {
          file.uuid = prefixUuid('link');
        } else {
          file.uuid = prefixUuid('file');
        }
      }
      return file;
    },
    setFiles: function setFiles(files) {
      var args = _.toArray(arguments);
      args.splice(0, 1, _.map(files, this.processFile, this));
      return this._super.apply(this, args);
    },
    addFileForUpload: function addFileForUpload(file) {
      if (this.canAddMore()) {
        var uploadQueue = this.getUploadQueue().slice();
        uploadQueue.push(file);
        this.setUploadQueue(uploadQueue, {
          trigger: true
        });
      }
    },
    fileDidUpload: function fileDidUpload(file) {
      this.addFile(file);
    },
    addFile: function addFile(file) {
      var files = this.getFiles().slice();
      files.push(file);
      this.setFiles(files, {
        trigger: true
      });
    },
    fileUploadDidFail: function fileUploadDidFail(file, error) {
      file.error = error;
      this.getView().fileUploadDidFail(file, error);
      this.getFailedFiles().push(file);
    },
    canAddMore: function canAddMore() {
      var files = this.getFiles(),
        uploadQueue = this.getUploadQueue();
      if (this.getMultiple() || files.length + uploadQueue.length == 0) {
        return true;
      }
      return false;
    },
    removeFileById: function removeFileById(uuid) {
      var file = _.find(this.getFiles(), function (f) {
        return f.uuid == uuid;
      });
      if (file) {
        this.setFiles(_.without(this.getFiles(), file));
      }
    },
    removeUploadById: function removeUploadById(uuid) {
      var file = _.find(this.getUploadQueue(), function (f) {
        return f.uuid == uuid;
      });
      if (file) {
        this.setUploadQueue(_.without(this.getUploadQueue(), file));
      }
    },
    getTemplateProperties: function getTemplateProperties() {
      return {
        multiple: this.getMultiple()
      };
    },
    refreshUploadQueuePropertyOnView: function refreshUploadQueuePropertyOnView(uploads, previousUploads) {
      var added = _.difference(uploads, previousUploads),
        removed = _.difference(previousUploads, uploads),
        view = this.getView();
      _.each(added, view.renderQueuedFile, view);
      _.each(removed, view.removeQueuedFile, view);
      if (_.isEmpty(uploads)) {
        view.hideUploadQueue();
      } else {
        view.showUploadQueue();
      }
      view.refreshAddBtn();
      view.refreshFileInstructions();
    },
    refreshFilesPropertyOnView: function refreshFilesPropertyOnView(files, previousFiles) {
      var added = _.difference(files, previousFiles),
        removed = _.difference(previousFiles, files),
        fn = function fn(file) {
          return file.link === true ? 'links' : 'files';
        },
        current = _.groupBy(files, fn),
        prev = _.groupBy(previousFiles, fn),
        view = this.getView();
      added = _.groupBy(added, fn);
      removed = _.groupBy(removed, fn);
      _.each(added.files, view.renderFile, view);
      _.each(removed.files, view.removeFile, view);
      _.each(added.links, view.renderLink, view);
      _.each(removed.links, view.removeLink, view);
      if (_.isEmpty(current.files)) {
        view.hideFileContainer();
      } else if (_.isEmpty(prev.files)) {
        view.showFileContainer();
      }
      if (_.isEmpty(current.links)) {
        view.hideLinkContainer();
      } else if (_.isEmpty(prev.links)) {
        view.showLinkContainer();
      }
      view.refreshAddBtn();
      view.refreshFileInstructions();
    },
    uploadFile: function uploadFile(file, documentId, progress) {
      return DocStore.upload(file.file, {
        progress: progress,
        documentId: documentId
      });
    },
    requestAddLink: function requestAddLink() {
      var view = this.getView(),
        data = view.getLinkData();
      if (this.canAddMore() && _.isString(data.url) && data.url.length) {
        this.addFile(LinkModel.model(data));
        view.hideLinkForm().bind(view).tap(view.clearLinkForm);
      }
    },
    fileUploadsDidFinish: function fileUploadsDidFinish() {},
    requestFileUpload: function requestFileUpload() {
      var uploads = this.getUploadQueue().slice(),
        view = this.getView(),
        _upload = null,
        file = null;
      _upload = function upload() {
        file = uploads.shift();
        if (!file) {
          return Promise.resolve();
        }
        if (file.error) {
          return _upload.call(this);
        }
        var previousProgress = 0;
        view.fileDidStartUploading(file);
        return Promise.resolve(this.uploadFile(file, this.getDocumentId(), function (progress) {
          if (progress > previousProgress) {
            view.updateFileProgress(file, progress);
            previousProgress = progress;
          }
        })).bind(this).tap(this.fileDidUpload).tap(function (newFile) {
          this.removeUploadById(file.uuid);
        }).caught(RSErrors.UploadAPIError, function (e) {
          this.fileUploadDidFail(file, e);
        }).tap(_upload);
      };
      return _upload.call(this);
    },
    fileUploadsCompleted: function fileUploadsCompleted() {
      var data = _.groupBy(this.getFiles(), function (file) {
        return file.link === true ? 'links' : 'files';
      });
      this.getModal().resolve([data.files || [], data.links || []]);
    },
    requestApply: function requestApply() {
      var view = this.getView();
      view.disableClose();
      return this.requestFileUpload().bind(this).tap(this.fileUploadsDidFinish).lastly(function () {
        view.enableClose();
      }).tap(function () {
        if (this.getFailedFiles().length == 0) {
          this.fileUploadsCompleted();
        } else {
          this.setFailedFiles([]);
        }
      });
    }
  });
  module.exports = UploadController;
});

